//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      zhhlxh: require("../assets/common-top.png"),
      footerImg: require("../assets/common-foot.png"),
      logoImg: require("../assets/logo.png"),
      isDisabled: false,
      activeId: "",
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      addForm: {
        activeId: "",
        cellPhone: "",
        checkCode: ""
      }
    };
  },
  computed: {
    smsMessage() {
      return this.count ? `${this.count} 秒` : "获取验证码";
    }
  },
  async mounted() {
    this.activeId = this.$route.params.activeId;
    if (!this.activeId) {
      this.activeId = this.$route.params.id;
    }
    this.addForm.activeId = this.activeId;
  },
  methods: {
    /**
     * 跳转注册
     */
    goRegister() {
      this.$router.push({
        name: "choose",
        params: { activeId: this.activeId }
      });
    },
    /**
     * 返回首页
     *
     */
    goback() {
      this.$router.push({ name: "loginSelect", params: { activeId: this.activeId } });
    },
    /**
     * 登陆
     *
     */
    async submitLogin() {
      if (!this.addForm.cellPhone) {
        this.showMsg("请输入手机号");
        return;
      }
      if (!this.addForm.checkCode || this.addForm.checkCode.length != 6) {
        this.showMsg("请输入正确的校验码");
        return;
      }
      const login = this.$apis.common.login;
      try {
        const { data } = (await this.$axios.post(login, this.addForm)) || {};
        localStorage.setItem('X_TOKEN', data.token);
        this.$router.push({
          name: "info",
          params: { id: data.data.id, cellPhone: data.data.cellPhone }
        });
      } catch (err) {
        this.showMsg(err);
      }
    },
    /**
     * 显示提示信息
     *
     */
    showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    async getMobilCode() {
      if (!this.addForm.cellPhone) {
        this.showMsg("请先输入手机号！");
        return;
      }

      if (this.count) return;

      if (this.interval) {
        clearInterval(this.interval);
      }
      try {
        const getCheckCode = this.$apis.common.checkCode;
        await this.$axios.get(
          `${getCheckCode}/${this.addForm.cellPhone}/${this.addForm.activeId}/2`
        );
        this.showMsg("短信发送成功！");
        this.count = 59;
        this.interval = setInterval(() => {
          if (this.count <= 0) {
            clearInterval(this.interval);
            return;
          }
          return this.count--;
        }, 1000);
      } catch (err) {
        console.log(err);
        if (this.interval) {
          clearInterval(this.interval);
        }
        this.count = 0;
        this.showMsg("请先注册！");
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/login.vue